module.exports = __webpack_public_path__ + "static/assets/8f3a702a1ac5a4cff5e5174f91e1482a.svg";